import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Admin } from 'app/model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export const appRelativeRoute = (commands: any[], route: ActivatedRoute): any[] => {
  const [entry, ...remain] = commands;
  return [route.snapshot.url.map((_) => '..').join('/') + entry, ...remain];
};

/** Get the Admin from the route data */
export const currentJobFromRoute = (route: ActivatedRoute): Observable<Admin> => {
  while (route) {
    if (route.snapshot.data.job) {
      return route.data.pipe(map((data) => data.job as Admin));
    }
    route = route.parent;
  }
  return of(null);
};

/** Get the jobId from the route params */
export const currentJobIdFromSnapshot = (route: ActivatedRouteSnapshot): number => {
  while (route) {
    if (route.params.jobId) {
      return +route.params.jobId;
    }
    route = route.parent;
  }
  return null;
};

/** Get the path (e.g. '/apps/job/1001/time/summary') from the snapshot */
export const getSnapshotPath = (route: ActivatedRouteSnapshot): string => {
  const paths = route.pathFromRoot.map((snap) => snap.url.map((seg) => seg.path).join('/'));
  // remove duplicate slashes
  return paths.join('/').replace(/\/\//g, '/');
};

/** Find a data object by name, by searching down from the root of the route */
export const findData = <T>(route: ActivatedRouteSnapshot, dataName: string): T => {
  let rt = route.root;
  let val: T;
  do {
    val = rt.data[dataName];
    rt = rt.firstChild;
  } while (!val && !!rt);
  return val;
};

// export const currentUserProfileFromRoute = (route: ActivatedRoute): Observable<User> => {
//   while (route) {
//     if (route.snapshot.data.initialData?.user) {
//       return route.data.pipe(map((data) => data.initialData.user as User));
//     }
//     route = route.parent;
//   }

//   return of(null);
// };

/** Return the root url of the application including base path, e.g "https://myhost.com/saweb/"
 * If no base element is defined, then return origin, e.g. "https://myhost.com/" */
export const getBaseUrl = (): string => {
  // get base element e.g. <base href="/saweb/">
  const base = document.getElementsByTagName('base')[0];
  return base ? base.href : window.location.origin + '/';
};

/** Return the base path e.g. "/saweb/", or "/" if no base defined */
export const getBasePrefix = (): string => {
  const base = getBaseUrl();
  return base.substring(window.location.origin.length);
};

/** Remove the base url from the given path, returning the relative url within the Angular app:
 * - "https://myhost.com/saweb/doc/7" => "doc/7"
 * - "/saweb/doc/7" => "doc/7"  */
export const trimBasePrefixFromPath = (path: string): string => {
  let base = getBaseUrl();
  if (path.startsWith(base)) {
    return path.substring(base.length);
  }
  base = getBasePrefix();
  if (path.startsWith(base)) {
    return path.substring(base.length);
  }
  return path;
};
